import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

@NgModule({
    imports: [CommonModule],
    providers: [],
    declarations: []
})
export class CoreModule {}
